// extracted by mini-css-extract-plugin
export default {"body":"_44c53cbb","buttons":"_9833352e","button":"_1eb2e5d","submit":"_8fe48f7f _1eb2e5d","cancel":"_1e59c42d _1eb2e5d"};